module.exports = __webpack_public_path__ + "img/template-four-bottom.eadca014.png";